<span class="c-info-text"><slot /></span>

<style>
  .c-info-text {
    color: var(--neutral-600);
    margin: 0 0 8px;
    font-size: 16px;
  }
</style>
